import { PlayerRef } from '@remotion/player';
import React, { useEffect, useRef } from 'react';

export const useIsBuffering = (
  playerRef: React.RefObject<PlayerRef | null>,
  delayMs = 0,
) => {
  const [buffering, setBuffering] = React.useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const { current } = playerRef;
    if (!current) {
      return;
    }

    let bufferingStartTime = 0;

    const onWaiting = () => {
      // 이전 타이머가 있으면 제거하여 중복 방지
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      bufferingStartTime = performance.now();
      if (delayMs > 0) {
        timerRef.current = setTimeout(() => setBuffering(true), delayMs);
      } else {
        setBuffering(true);
      }
    };

    const onResume = () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      bufferingStartTime = 0;
      setBuffering(false);
    };

    current.addEventListener('waiting', onWaiting);
    current.addEventListener('resume', onResume);

    return () => {
      current.removeEventListener('waiting', onWaiting);
      current.removeEventListener('resume', onResume);
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [playerRef, delayMs]);

  return buffering;
};
